
import { gsap } from "gsap"
import {scrollInstance} from './main'
class SelettoreLingua{
    constructor(selettore){
        this.selettore = selettore
        this.selectBody = this.selettore.querySelector('.select__body')
        this.selectBodyWrapper = this.selectBody.querySelector('.select__body__wrapper')

        this.selettore.addEventListener('click', () => {
/*             scrollInstance.stop() 
            setTimeout( () => {
                scrollInstance.start()
            },200)     */       
            this.toggleLanguage()
        })


        window.addEventListener('scroll', () => {
            if(this.selettore.classList.contains('opened')){
                this.closeLanguage()
            }
        })
    }
    toggleLanguage(){
        if(this.selettore.classList.contains('opened')){
            this.closeLanguage()
        }   
        else{
            this.openLanguage()
        }
    }    

    closeLanguage(){
        this.selettore.classList.remove('opened')
        gsap.to(this.selectBody, {
            duration: 0.5,
            height: 0
        })
    }

    openLanguage(){
        let height = this.selectBodyWrapper.getBoundingClientRect().height
        this.selettore.classList.add('opened')
        gsap.to(this.selectBody, {
            duration: 0.5,
            height: height
        })

    }
}

export {SelettoreLingua}